import ViewOffFilled16 from '@carbon/icons-react/es/view--off--filled/16';
import { Space, Tooltip, Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { HelperText01 } from 'components/styles';
import { useAccount } from 'hooks/use-account';
import { useTranslate } from 'hooks/use-translation';
import styles from './inferred-progress-days.module.css';

const { Text } = Typography;

const Icon = styled(ViewOffFilled16)`
  color: var(--yellow-50);
`;
const Container = styled(Text)<TextProps>`
  ${HelperText01};
`;

export const InferredProgressDays = ({ count = 0 }: { count: number }) => {
  const {
    company: { companyName },
  } = useAccount();
  const translate = useTranslate();
  const text = useMemo(() => {
    if (count > 0) {
      return translate('n_day_early', { count });
    }
    if (count < 0) {
      return translate('n_day_late', { count: Math.abs(count) });
    }

    return translate('on_time');
  }, [count, translate]);

  return (
    <Space size={0}>
      <Tooltip
        title={translate('project.overview.project_details.sub_title', {
          companyName,
        })}
      >
        <div>
          <IconShell size="xsmall" icon={<Icon />} />
        </div>
      </Tooltip>
      <Container type={count < 0 ? 'danger' : 'success'}>{text}</Container>
    </Space>
  );
};

export const EstDueDate = ({ count = 0 }) => {
  if (count > 0) {
    return (
      <p className={classNames(styles.ipCount, styles.text_green)}>
        <FormattedMessage id="n_days_early" values={{ count }} />
      </p>
    );
  }

  if (count < 0) {
    return (
      <p className={classNames(styles.ipCount, styles.text_red)}>
        <FormattedMessage
          id="n_days_late"
          values={{ count: Math.abs(count) }}
        />
      </p>
    );
  }

  if (count === 0) {
    return (
      <p className={classNames(styles.ipCount, styles.text_green)}>
        <FormattedMessage id="on_time" />
      </p>
    );
  }

  return null;
};
